import React, { createContext, useContext, useCallback } from 'react';

interface NoAccessContextType {
    onNoAccess: (message: string) => void;
}

const NoAccessContext = createContext<NoAccessContextType | undefined>(undefined);

interface NoAccessProviderProps {
    children: React.ReactNode;
    onNoAccess: (message: string) => void;
}

export const NoAccessProvider: React.FC<NoAccessProviderProps> = ({ children, onNoAccess }) => {
    const handleNoAccess = useCallback((message: string) => {
        onNoAccess(message);
    }, [onNoAccess]);

    return (
        <NoAccessContext.Provider value={{ onNoAccess: handleNoAccess }}>
            {children}
        </NoAccessContext.Provider>
    );
};

export const useNoAccess = (): NoAccessContextType => {
    const context = useContext(NoAccessContext);
    if (!context) {
        throw new Error('useNoAccess must be used within a NoAccessProvider');
    }
    return context;
};
